import { render, staticRenderFns } from "./IncidentOttDetail.vue?vue&type=template&id=5d2eb52f&"
import script from "./IncidentOttDetail.vue?vue&type=script&lang=js&"
export * from "./IncidentOttDetail.vue?vue&type=script&lang=js&"
import style0 from "./IncidentOttDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports